import { ROUTES } from '../../routes/consts';
import { InstallAppNextLabel } from '../../shared/InstallationDialog';
import { StepConfig } from '../../shared/MultiStepDialog';
import { spawn } from '../../utils/translations';
import { STEP_IDS, FORM_IDS } from './consts';
import { CarouselStepConfig } from './types';
import installStepCreateApp from '/images/github-installation/install-app-create-app.svg';
import installStepSelectRepos from '/images/github-installation/install-app-select-repos.svg';

const spawnSteps = spawn('dialogs.github-installation.steps');

export const getSteps = (): StepConfig[] => [
  {
    id: STEP_IDS.ORGANIZATION_DETAILS,
    path: ROUTES.GITHUB_INSTALLATION_STEP_1,
    title: spawnSteps('organization-details.title'),
    formId: FORM_IDS.ORGANIZATION_DETAILS,
    shouldShowBackButton: false,
    shouldShowCancelButton: true,
  },
  {
    id: STEP_IDS.REVIEW_MANIFEST,
    path: ROUTES.GITHUB_INSTALLATION_STEP_2,
    title: spawnSteps('review-manifest.title'),
    shouldShowBackButton: true,
    isNextInitiallyEnabled: false,
  },
  {
    id: STEP_IDS.INSTALL_APP,
    path: ROUTES.GITHUB_INSTALLATION_STEP_3,
    title: spawnSteps('install-app.title'),
    formId: FORM_IDS.INSTALL_APP,
    shouldShowBackButton: true,
    nextLabel: (
      <InstallAppNextLabel text={spawnSteps('install-app.next-label')} />
    ),
    isNextInitiallyEnabled: false,
  },
  {
    id: STEP_IDS.CHECK_CONNECTION,
    path: ROUTES.GITHUB_INSTALLATION_STEP_4,
    title: spawnSteps('check-connection.title'),
    shouldShowBackButton: true,
    isNextInitiallyEnabled: false,
  },
  {
    id: STEP_IDS.RECOMMENDED_DISPLAY,
    path: ROUTES.GITHUB_INSTALLATION_STEP_5,
    title: spawnSteps('recommended-display.title'),
    shouldShowBackButton: true,
  },
  {
    id: STEP_IDS.ENABLE_QODO,
    path: ROUTES.GITHUB_INSTALLATION_STEP_6,
    title: spawnSteps('enable-qodo.title'),
    shouldShowBackButton: true,
    nextLabel: spawnSteps('enable-qodo.next-label'),
  },
];

export const getInstallationGuideCarouselSteps = (): CarouselStepConfig[] => [
  { id: 'create-app', image: installStepCreateApp },
  { id: 'select-repositories', image: installStepSelectRepos },
];
